import React, { useCallback, useEffect, useState } from "react";
import { DatePicker, Form, Input, Select } from "antd";
import { responseNotification } from "../../../utils/notify";
import { ImageUploader, SubmitResetBtn } from "../../common";
import { useSelector } from "react-redux";
import axios from "axios";
import moment from "moment";
import MerchantLayout from "../Layout";
import { useNavigate } from "react-router";
const PersonalDetailsAdd = () => {
  const { token } = useSelector((state) => (state as any)?.authReducer);
  const navigate = useNavigate();
  const [documentType, setDocumentType] = useState("NID");
  const [gender, setGender] = useState("MALE");
  const [dateOfBirth, setDateOfBirth] = useState("");
  const [identificationType, setIdentificationType] = useState<any>("NID");
  const [profilePictureUrl, setProfilePictureUrl] = useState<string>();
  const [identificationDocumentUrl, setIdentificationDocumentUrl] = useState("");
  const [startUploadFront, setStartUploadFront] = useState(false);

  const [singleMerchantInfo, setSingleMerchantInfo] = useState<any>({
    loading: false,
    data: null,
  });
  const [frontSidePicture, setFrontSidePicture] = useState<string>();
  const [backSidePicture, setBackSidePicture] = useState<string>();
  const [identificationUrl2, setIdentificationUrl2] = useState("");
  const [utilityImageUrl, setUtilityImageUrl] = useState("");
  const [uploadUtilityImage, setUploadUtilityImage] = useState(false);
  const [startIdentificationUpload2, setStartIdentificationUpload2] =
    useState(false);
  const [startUploadProfilePic, setStartUploadProfilePic] = useState<
  "Initiated" | "Uploading" | "Uploaded"
>();

  const [uploadFrontSidePicture, setUploadFrontSidePicture] = useState<
    "Initiated" | "Uploading" | "Uploaded"
  >();
  const [uploadBackSidePicture, setUploadBackSidePicture] = useState<
    "Initiated" | "Uploading" | "Uploaded"
  >();
  const [uploadProfilePicture, setUploadProfilePicture] = useState<
    "Initiated" | "Uploading" | "Uploaded"
  >();
  const [loading, setLoading] = useState(false);

  const [form] = Form.useForm();

  const fetchMerchantDetails = useCallback(() => {
    try {
      setSingleMerchantInfo({ loading: true, data: null });
      axios
        .get(`${process.env.REACT_APP_RIDER_API}/details`, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        })
        .then((data) => {
          if (data.status === 200) {
            setSingleMerchantInfo({
              loading: false,
              data: data?.data?.merchant,
            });
            setIdentificationDocumentUrl(
              data?.data?.merchant?.merchantPersonalDetail
                ?.identificationDocumentUrl
            );
            setIdentificationUrl2(
              data?.data?.merchant?.merchantPersonalDetail
                ?.identificationDocumentUrl2
            );
            setUtilityImageUrl(data?.data?.merchant?.merchantPersonalDetail?.utilityImage);
            setProfilePictureUrl(
              data?.data?.merchant?.merchantPersonalDetail?.profilePicture
            );
            setDateOfBirth(
              data?.data?.merchant?.merchantPersonalDetail?.dateOfBirth
            );
          } else {
            setSingleMerchantInfo({ loading: false, data: null });
            responseNotification(
              data.statusText || "something went wrong",
              "error"
            );
          }
        })
        .catch((err) => {
          setSingleMerchantInfo({ loading: false, data: null });
        });
    } catch (error) {
      setSingleMerchantInfo({ loading: false, data: null });
    }
  }, [token]);

  useEffect(() => {
    fetchMerchantDetails();
  }, [fetchMerchantDetails, token]);

  useEffect(() => {
    if (singleMerchantInfo.data) {
      form.resetFields(Object.keys(singleMerchantInfo.data as any));
     
    }
  }, [form, singleMerchantInfo.data]);

  function handleChange(value) {
    setDocumentType(value);
  }
    useEffect(() => {
    if (startUploadProfilePic) {
      form?.submit();
    }
  }, [form, startUploadProfilePic]);


  const onSubmit = async (data: any) => {
    setLoading(true);
    const readyData = data && {
      name: data.name,
      email: data.email,
      gender: gender,
      dateOfBirth: dateOfBirth,
      identificationDocumentNumber: data.identificationDocumentNumber,
      identificationDocumentType: identificationType,
      identificationDocumentUrl: identificationDocumentUrl || "",
      identificationDocumentUrl2: identificationUrl2 || "",
      profilePicture: profilePictureUrl || "",
    };

    await fetch(`${process.env.REACT_APP_RIDER_API}/merchant/personal-info`, {
      method: "PUT",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(readyData),
    })
      .then((res) => res.json())
      .then((res) => {
        setLoading(false);

        if (res.statusCode === 200) {
          responseNotification(data?.message, "success");
          form.resetFields();
          //window.location.reload();
          navigate(-1);
          // navigate("/account/my-profile");
        } else if (res.status === 500) {
          responseNotification("Internal server error", "error");
        } else {
          responseNotification(res.message || "something wrong", "warning");
        }
      })
      .catch((err) => {
        setLoading(false);
        responseNotification(`${"Internal server error"} ${err}`, "error");
        console.error("err", err);
      });
  };

  const resetData = () => {
    form?.resetFields();
  };

  useEffect(() => {
    if (singleMerchantInfo?.data) {
      form.resetFields();
      setIdentificationDocumentUrl(
        singleMerchantInfo?.data?.merchantPersonalDetail
          ?.identificationDocumentUrl
      );
      setUtilityImageUrl(singleMerchantInfo?.data?.merchantPersonalDetail
        ?.utilityImage);
      setIdentificationUrl2(
        singleMerchantInfo?.data?.merchantPersonalDetail
          ?.identificationDocumentUrl2
      );
      setProfilePictureUrl(
        singleMerchantInfo?.data?.merchantPersonalDetail?.profilePicture
      );
      setDateOfBirth(
        singleMerchantInfo?.data?.merchantPersonalDetail?.dateOfBirth
      );
    }
  }, [form, singleMerchantInfo?.data]);

  return (
    <MerchantLayout
      merchantId={singleMerchantInfo?.data?.id}
      title={`Merchant Profile Update`}
      subTitle={`Merchant Profile Update`}
    >
      <div className="content-body rounded-2xl bg-white p-4 min-h-full">
        <Form
          name="control-hooks"
          onFinish={onSubmit}
          form={form}
          layout="vertical"
          initialValues={{
            ...singleMerchantInfo?.data?.merchantPersonalDetail,
            name:
              singleMerchantInfo?.data?.merchantPersonalDetail?.fullName || "",
            email:
              singleMerchantInfo?.data?.merchantPersonalDetail?.email || "",
          }}
        >
          <div className="grid grid-cols-2 gap-4">
            <Form.Item
              name="name"
              hasFeedback
              label="Owner Name"
              rules={[
                {
                  required: true,
                  message: "Name is Required!",
                },
              ]}
            >
              <Input type="text" id="name" placeholder="Enter name" />
            </Form.Item>

            <Form.Item
              name="email"
              hasFeedback
              label="Email Address"
              rules={[
                {
                  required: true,
                  message: "Email is Required!",
                },
              ]}
            >
              <Input type="text" id="email" placeholder="Enter email" />
            </Form.Item>

            <Form.Item
              name="gender"
              hasFeedback
              label="Select Gender"
              rules={[
                {
                  required: false,
                  message: "Gender is Required!",
                },
              ]}
            >
              <Select
                placeholder="Select Gender"
                optionFilterProp="children"
                defaultValue={gender}
                onChange={(val) => setGender(val)}
                options={[
                  { label: "MALE", value: "MALE" },
                  { label: "FEMALE", value: "FEMALE" },
                ]}
              ></Select>
            </Form.Item>

            

            <Form.Item
              name="identificationDocumentType"
              hasFeedback
              label="Document Type"
              rules={[
                {
                  required: true,
                  message: "Document Type is Required!",
                },
              ]}
            >
              <Select
                defaultValue={identificationType}
                onChange={(val: any) => setIdentificationType(val)}
                options={[
                  {
                    label: "NID",
                    value: "NID",
                  },
                  {
                    label: "PASSPORT",
                    value: "PASSPORT",
                  },
                  {
                    label: "BIRTH CERTIFICATE",
                    value: "BIRTH_CERTIFICATE",
                  },
                ]}
              ></Select>
            </Form.Item>
            

            <Form.Item
                  name="identificationDocumentNumber"
                  hasFeedback
                  label={`${identificationType.replace("_", " ")} Number`}
                  rules={[
                    {
                      required: false,
                      message: "Number is Required!",
                    },
                  ]}
                >
                  <Input
                    id="identificationDocumentNumber"
                    type="text"
                    className="input-box"
                    placeholder="Enter Id Number"
                  />
                </Form.Item>
          </div>

          <div className="flex flex-col gap-2">
            <div className="grid grid-cols-4 gap-4">
              <div className="basis-0 pr-2">
                <span className="text-md">Profile Picture</span>
                <ImageUploader
                  imgUrl={profilePictureUrl}
                  startUpload={startUploadProfilePic}
                  setStartUpload={(val) => setStartUploadProfilePic(val)}
                  setGeneratedImgUrl={(url) => setProfilePictureUrl(url)}
                />
              </div>

              <div className="basis-0 pr-2">
                <span className="text-md">Front Image</span>
                <ImageUploader
                  imgUrl={identificationDocumentUrl}
                  startUpload={startUploadFront}
                  setStartUpload={(val) => setStartUploadFront(val)}
                  setGeneratedImgUrl={(frontUrl) =>
                    setIdentificationDocumentUrl(frontUrl)
                  }
                />
              </div>
              {identificationType !== "BIRTH_CERTIFICATE" && (
                <>
                  <div className="basis-0">
                    <span className="text-md">Back Image</span>
                    <ImageUploader
                      imgUrl={identificationUrl2}
                      startUpload={startIdentificationUpload2}
                      setStartUpload={(val) =>
                        setStartIdentificationUpload2(val)
                      }
                      setGeneratedImgUrl={(backUrl) =>
                        setIdentificationUrl2(backUrl)
                      }
                    />
                  </div>
                </>
              )}

              <div className="basis-0">
                <span className="text-md">Utility Bill</span>
                <ImageUploader
                  imgUrl={utilityImageUrl}
                  startUpload={uploadUtilityImage}
                  setStartUpload={(val: any) => setUploadUtilityImage(val)}
                  setGeneratedImgUrl={(billUrl: any) =>
                    setUtilityImageUrl(billUrl)
                  }
                />
              </div>
            </div>
          </div>
 
          <div className="mt-2">
          <SubmitResetBtn
            onClickSubmit={(e) => {
              e.preventDefault();
              setStartUploadProfilePic("Uploading");
              setStartUploadFront(true);
              setStartIdentificationUpload2(true);
              setUploadUtilityImage(true);
            }}
            onClickReset={resetData}
          />
          </div>
        </Form>
      </div>
    </MerchantLayout>
  );
};

export default PersonalDetailsAdd;
